/* global Config */

import {mapValues} from 'lodash';

const configBase = {
    baseUrl: Config.base.baseUrl,
    contentType: 'application/json',
    crossDomain: true,
    method: 'GET',
    queryType: '',
    responseType: 'json',
    timeout: 120000,
};

const servicesConfig = {
    addStoreFront: {
        method: 'POST',
        path: 'storefronts',
    },
    aliasesList: {
        baseUrl: Config.base.catalogUrl,
        path: 'genre/aliases',
    },
    deleteShelf: {
        baseUrl: Config.base.catalogUrl,
        method: 'DELETE',
        path: 'shelf',
        routerKeys: [{routerKey: 'shelfid', searchType: 'path'}],
    },
    deleteStoreFront: {
        method: 'DELETE',
        path: 'storefronts',
        routerKeys: [{routerKey: 'storeFrontId', searchType: 'path'}],
    },
    featuredFolderList: {
        baseUrl: Config.base.catalogUrl,
        path: 'folders/featured',
    },
    featuredFolderListAll: {
        baseUrl: Config.base.catalogUrl,
        path: 'folders/featured?ignoreDataPackage=true',
    },
    loadHomeShelf: {
        baseUrl: Config.base.catalogUrl,
        path: 'shelf/homeShelf',
    },
    loadParentShelfDetail: {
        baseUrl: Config.base.catalogUrl,
        path: 'shelf',
        routerKeys: [{routerKey: 'parentshelfid', searchType: 'path'}],
    },
    loadShelfDetail: {
        baseUrl: Config.base.catalogUrl,
        path: 'shelf',
        routerKeys: [{routerKey: 'editshelfid', searchType: 'path'}],
    },
    loadSubShelves: {
        baseUrl: Config.base.catalogUrl,
        path: 'shelf',
        routerKeys: [{routerKey: 'shelfid', searchType: 'path'}],
    },
    loadSubShelvesResults: {
        baseUrl: Config.base.catalogUrl,
        path: 'subShelves',
    },
    networkList: {
        baseUrl: Config.base.catalogUrl,
        path: 'network/networks',
    },
    promotedNetworkList: {
        baseUrl: Config.base.catalogUrl,
        path: 'networkLists',
    },
    storeFronts: {
        path: 'storefronts',
        route: 'store-fronts',
    },
    storeFrontDetail: {
        path: 'storefronts',
        routerKeys: [{routerKey: 'storeFrontId', searchType: 'path'}],
    },
    shelfItems: {
        formName: 'shelfItems',
        getParams: {},
        path: 'shelves/shelf',
        route: 'shelf-items',
    },
    updateShelf: {
        baseUrl: Config.base.catalogUrl,
        method: 'PUT',
        path: 'shelf',
    },
    updateStoreFront: {
        method: 'PUT',
        path: 'storefronts',
        routerKeys: [{routerKey: 'storeFrontId', searchType: 'path'}],
    },
};

export default mapValues(servicesConfig, config => ({...configBase, ...config}));
